
document.addEventListener('DOMContentLoaded', function () {
    const articleLikeButtons = document.querySelectorAll('.article-card__like-btn');

    articleLikeButtons.forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            // Extract article data from data attributes
            const articleData = {
                id: this.dataset.articleId,
                title: this.dataset.articleTitle,
                url: this.dataset.articleUrl,
                author: this.dataset.articleAuthor,
                publishedAt: this.dataset.articlePublishedAt,
                tags: this.dataset.articleTags ? this.dataset.articleTags.split(',') : [],
                category: this.dataset.articleCategory,
                categoryId: this.dataset.articleCategoryId
            };

            button.classList.toggle('active');

            if (button.classList.contains('active')) {
                button.setAttribute('aria-label', 'Unlike article');
            } else {
                button.setAttribute('aria-label', 'Like article');
            }

            // Call the function with article data
            console.log("Article like button clicked", articleData);
            // alert("Article like button clicked" + JSON.stringify(articleData, null, 2));
        });

    });
});
